import Typography from '@material-ui/core/Typography';
import { FC, ReactElement } from 'react';

import { ITeamMemberMapped } from '~/utils/clientAllocation';

import layoutStyles from '../../../shared/components/EditAllocationFormLayout/EditAllocationFormLayout.module.scss';
import useAllocationChangeTracking from '../../../shared/hooks/useAllocationChangeTracking';
import { IEditAllocationFormValues } from '../../../shared/model/types';
import useGetClientsGU from '../../../shared/hooks/useGetClientsGU';
import useClientAllocationsUpdate from '../../hooks/updateAllocations/useClientAllocationsUpdate';
import AllocationClientRowItem from '../ClientsRowItem/AllocationClientRowItem';
import AllocationClientsSelectGU from '../SelectFields/AllocationClientsSelectGU';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AllocationClientsListGU: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const { markChanged, markDeleted } = useAllocationChangeTracking<IEditAllocationFormValues>({
    changedField: 'changedAllocationsIds',
    deletedField: 'deletedAllocationsIds',
  });
  const {
    fields: clientsAllocationsFields,
    updateAllocations,
    removeClientAt,
  } = useClientAllocationsUpdate(teamMemberIdx);

  const { loadMore, loading, items: clientOptions } = useGetClientsGU(clientsAllocationsFields);

  return (
    <>
      <Typography variant="subtitle1" className={layoutStyles.assignedClientsSectionTitle}>
        Client Allocations
      </Typography>

      <AllocationClientsSelectGU
        loading={loading}
        loadMore={loadMore}
        teamMemberIdx={teamMemberIdx}
        updateAllocations={updateAllocations}
      />

      {clientsAllocationsFields.map((field, clientIdx) => {
        const clientTeams = clientOptions.find(client => client.id === field.clientId)?.teams;

        return (
          <AllocationClientRowItem
            key={field.id}
            field={field}
            clientIdx={clientIdx}
            teamMemberIdx={teamMemberIdx}
            memberId={teamMember.id}
            fieldsCount={clientsAllocationsFields.length}
            onMarkChanged={markChanged}
            onMarkDeleted={markDeleted}
            onRemove={removeClientAt}
            availableClientTeams={clientTeams}
          />
        );
      })}
    </>
  );
};

export default AllocationClientsListGU;
